"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find-index");
require("core-js/modules/es6.function.name");
var _issueApply = require("@/api/issue/issueApply");
var _store = _interopRequireDefault(require("@/store"));
var _utils = require("@/utils");
var _booking = require("@/api/bookSpace/booking");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'add',
  data: function data() {
    return {
      isCnLang: true,
      headers: {
        Authorization: 'Bearer ' + _store.default.getters.access_token
      },
      dialogImageUrl: '',
      dialogVisible: false,
      form: {
        issueTypeName: '',
        issueDescription: ''
      },
      rules: {
        issueTypeName: [{
          required: true,
          message: this.$t('portContacts.typeIsNull'),
          trigger: 'blur'
        }],
        issueDescription: [{
          required: true,
          message: this.$t('portContacts.contentIsNull'),
          trigger: 'blur'
        }]
      },
      attaches: [],
      issueTypeList: [{
        label: '服务质量',
        labelEn: 'Service quality',
        value: '服务质量'
      }, {
        label: '集装箱',
        labelEn: 'Container',
        value: '集装箱'
      }, {
        label: '班期',
        labelEn: 'Schedule',
        value: '班期'
      }, {
        label: '舱位',
        labelEn: 'Cabin space',
        value: '舱位'
      }, {
        label: '中转',
        labelEn: 'Transit',
        value: '中转'
      }, {
        label: '系统/电子商务',
        labelEn: 'System/e-commerce',
        value: '系统/电子商务'
      }, {
        label: '其他',
        labelEn: 'Other',
        value: '其他'
      }],
      fileList: [],
      fileList1: [],
      photoList: [],
      attachList: [],
      photoItem: {
        avatarUrl: ''
      }
    };
  },
  methods: {
    uploadFile: function uploadFile(item) {
      var _this = this;
      this.loading = (0, _utils.load)();
      var formDatas = new FormData();
      formDatas.append("file", item.file);
      formDatas.append("bucket", 'workorder');
      (0, _booking.setUploadFile)(formDatas).then(function (res) {
        _this.photoList.push({
          attachMinioUrl: 'workorder-' + res.fileMinioName,
          attachName: res.fileName,
          attachType: 0
        });
      }).finally(function () {
        _this.loading.close();
      });
    },
    uploadFile1: function uploadFile1(item) {
      var _this2 = this;
      this.loading = (0, _utils.load)();
      var formDatas = new FormData();
      formDatas.append("file", item.file);
      formDatas.append("bucket", 'workorder');
      (0, _booking.setUploadFile)(formDatas).then(function (res) {
        _this2.attachList.push({
          attachMinioUrl: 'workorder-' + res.fileMinioName,
          attachName: res.fileName,
          attachType: 1
        });
      }).finally(function () {
        _this2.loading.close();
      });
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    createIssue: function createIssue() {
      var _this3 = this;
      this.$refs.form.validate(function (vaild) {
        if (vaild) {
          _this3.$confirm(_this3.$t('portContacts.sureSubmit'), _this3.$t('home.tips'), {
            confirmButtonText: _this3.isCnLang ? '确定' : 'OK',
            cancelButtonText: _this3.isCnLang ? '取消' : 'Cancel',
            type: 'warning'
          }).then(function () {
            _this3.loading = true;
            _this3.attaches = _this3.photoList.concat(_this3.attachList);
            (0, _issueApply.issueApply)(Object.assign({}, {
              attaches: _this3.attaches
            }, {
              issue: _this3.form
            })).then(function (response) {
              if (response.success === true) {
                _this3.$alert(_this3.$t('portContacts.success'), _this3.$t('portContacts.feedbackInfo'), {
                  confirmButtonText: _this3.$t('button.sure'),
                  callback: function callback(action) {
                    _this3.loading = false;
                  }
                });
              } else {
                _this3.$alert(_this3.$t('portContacts.success'), _this3.$t('portContacts.feedbackInfo'), {
                  confirmButtonText: _this3.$t('button.sure'),
                  callback: function callback(action) {
                    _this3.loading = false;
                  }
                });
              }
            });
          }).catch(function () {});
        }
      });
    },
    handlePhotoSuccess: function handlePhotoSuccess(res, file) {
      this.photoItem.avatarUrl = URL.createObjectURL(file.raw);
      this.photoList.push({
        id: this.fileList.length + this.fileList1.length,
        attachMinioUrl: res.data.bucketName + '-' + res.data.fileName,
        attachName: file.name,
        attachType: 0
      });
    },
    handlePhotoChange: function handlePhotoChange(file, fileList) {
      this.fileList = fileList;
    },
    /**
     * 找到当前file在fileList中的下标，删除photoList及fileList对应元素
     */
    handlePhotoRemove: function handlePhotoRemove(file) {
      var indexOfFile = (this.fileList || []).findIndex(function (item) {
        return item.uid === file.uid;
      });
      (0, _booking.deleteByFileId)(this.photoList[indexOfFile].ecomEbusinessIssueAttachId);
      this.photoList.splice(indexOfFile, 1);
      this.fileList.splice(indexOfFile, 1);
    },
    handleFileSuccess: function handleFileSuccess(res, file) {
      this.attachList.push({
        id: this.fileList.length + this.fileList1.length,
        attachMinioUrl: res.data.bucketName + '-' + res.data.fileName,
        attachName: file.name,
        attachType: 1
      });
    },
    handleFileChange: function handleFileChange(file, fileList) {
      this.fileList1 = fileList;
    },
    handleFileRemove: function handleFileRemove(file, fileList) {
      var indexOfAttach = (this.fileList1 || []).findIndex(function (item) {
        return item.uid === file.uid;
      });
      (0, _booking.deleteByFileId)(this.attachList[indexOfAttach].ecomEbusinessIssueAttachId);
      this.attachList.splice(indexOfAttach, 1);
      this.fileList1.splice(indexOfAttach, 1);
    },
    beforeFileUpload: function beforeFileUpload(file) {
      var isLt10M = file.size / 1024 / 1024 < 10;
      var isLtLong = file.name.length < 100;
      if (!isLtLong) {
        this.$message.error(this.$t('portContacts.fileNameIsLong'));
      }
      if (!isLt10M) {
        this.$message.error(this.$t('portContacts.fileIsLarge'));
      }
      return isLt10M && isLtLong;
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isImage = file.type.indexOf('image') !== -1;
      var isLt10M = file.size / 1024 / 1024 < 10;
      if (!isImage) {
        this.$message.error(this.$t('portContacts.imageIsFalse'));
      }
      if (!isLt10M) {
        this.$message.error(this.$t('portContacts.photoIsLarge'));
      }
      return isLt10M && isImage;
    },
    beforeRemove: function beforeRemove(file, fileList) {
      return this.isCnLang ? this.$confirm("\u786E\u5B9A\u79FB\u9664 ".concat(file.name, "\uFF1F")) : this.$confirm("Remove ".concat(file.name, "\uFF1F"));
    }
  },
  mounted: function mounted() {},
  created: function created() {
    this.isCnLang = this.$i18n.locale === 'zh';
  }
};